<template lang="pug">
  .container.grid-xl.py-2
    .flex-centered.full-height.loading.loading-lg(v-if="loading")
    .panel(v-else)
      .panel-header
        .h4.text-primary Editar o Documento
          span(v-if='resource')
          small  nº
          |  {{ resource.numero }}/{{ resource.ano }}
        div(v-if='resource')
          .text-gray {{ resource.modelo.titulo }}
          .text-gray {{ resource.modelo.descricao }}
        .divider
        div
          steps.pt-2(:steps="steps")
          .divider
      .panel-body.mb-2
        router-view(:steps="steps" edit)
</template>

<script>
import editLayoutMixin from './editLayoutMixin'
import mapRoutes from './mapRoutes'

export default {
  mixins: [editLayoutMixin],
  computed: {
    mapRoutes() {
      return mapRoutes('edit')
    },
  },
}
</script>
